import React from 'react';
import PropTypes from 'prop-types';
import ContainerCard from './ContainerCard';
import NewContainerButton from './NewContainerButtonConnector';
import ErrorCircleIcon from '../../../themes/svg/errorCircleIcon';
import ContainerError from './ContainerError';

const ContainerCardsWrapper = props => (
  <div className="containerCards">
    {(props.invalidItemsCount > 0 && props.discontinuedItemsCount > 0 && !props.isMandi) ?
    (<ContainerError
      errorMessage="Please review and edit the highlighted products below. For help,"
      phoneNumber={props.phoneNumber}
    />) :
     (props.discontinuedItemsCount > 0 && !props.isMandi && (
     <ContainerError
       errorMessage="Swap or delete the discontinued products below. For help,"
       phoneNumber={props.phoneNumber}
     />)) ||
     (props.invalidItemsCount > 0 && !props.isMandi && (<ContainerError
       errorMessage="Edit the highlighted products below to correct
    customization no longer available. For help,"
       phoneNumber={props.phoneNumber}
     />))
    }

    {props.invalidItemsCount > 0 && props.isMandi && (
      <div className="error">
        <ErrorCircleIcon />
      Please review and edit the highlighted products below.
      </div>)
    }
    {props.containerIds.map((id, idx) => <ContainerCard containerId={id} key={id} index={idx} />)}
    {!props.isLockedOrOrdered && !props.isMandi && (
      <NewContainerButton />
    )}
  </div>
);

ContainerCardsWrapper.propTypes = {
  containerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  invalidItemsCount: PropTypes.number.isRequired,
  discontinuedItemsCount: PropTypes.number.isRequired,
  isLockedOrOrdered: PropTypes.bool.isRequired,
  isMandi: PropTypes.bool,
  phoneNumber: PropTypes.string.isRequired,
};

ContainerCardsWrapper.defaultProps = {
  isMandi: null,
};

export default ContainerCardsWrapper;
